export default __webpack_public_path__ + "static/media/giraffe.63069747.ogg";